import { IBodyTripSelected } from "models/TripInterface";
import { getAxios, postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";


export function setBookingsCall(
  body: IBodyTripSelected,
  callback: Function,
  errorCallback: Function
) {
  postAxios(apiNames.BKING, true, "/bookings", body)
    .then((data: any) => {
      callback(data);
    })
    .catch((error: any) => {
      errorCallback(error);
    });
}


export function setBookingsMultiCITCall(
  body: any,
  callback: Function,
  errorCallback: Function
) {
  postAxios(apiNames.BKING, true, "/bookings/cit", body,undefined,180000)
    .then((data: any) => {
      callback(data);
    })
    .catch((error: any) => {
      errorCallback(error);
    });
}



export function getPromoCodeCall(body: any, callback: Function, errorCallback: Function, mock?: string) {
  if (mock == "true") {
    const mock={
          "data": {
            "isValid": true,
            "voucherCode": "DOCO5",
            "voucherAmount": 1500,
            "discountType": "DOCO"
          }
  }
  
    if(body){
      callback(mock)
    }else{
      callback(mock)
    }
   
  } else {
    postAxios(apiNames.BKING, true, `/discounts/check`,body).then((data: any) => {
      callback(data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  }
}



export function getProvisionCardCall( callback: Function, errorCallback: Function, mock?: string) {
  if (mock == "true") {
    const mock={
          "data": {
            "amount": 1500,

          }
  }
  

      callback(mock.data.amount)
  
   
  } else {
    getAxios(apiNames.BKING, true, `/discounts/check`).then((data: any) => {
      callback(data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  }
}


